/* eslint-disable indent */
import React from 'react';
import {useRecoilValue, useSetRecoilState} from 'recoil';
import {
  chosenColorsFilters,
  colorBrands,
  searchQuery,
} from '../../state/colors';
import UIDropdown from '../UICommon/UIDropdown';
import ChooseColorsFiltersCheckbox from './ChooseColorsFiltersCheckbox';

const ChooseColorsFilters: React.FC = ({}) => {
  const setText = useSetRecoilState(searchQuery);
  const text: any = useRecoilValue(searchQuery);
  const brands: any = useRecoilValue(colorBrands);
  const setChosenFilters = useSetRecoilState(chosenColorsFilters);
  const chosenFilters: any = useRecoilValue(chosenColorsFilters);

  return (
    <div className='flex justify-between space-x-4'>
          <input
            type='text'
            value={text}
            placeholder='Sök...'
            onChange={(e) => setText(e.target.value!)}
            className='border border-gray-button text-sm font-Manrope rounded-md h-10
             focus:border-gray-900 outline-none pl-4 h-full mb-2 md:mb-0 w-full'
          />
        {brands && (
          <UIDropdown name='Märke'>
            {brands?.map((el: any, idx: number) => {
              return (
                <ChooseColorsFiltersCheckbox
                  type='brands'
                  id={el.id}
                  key={idx}
                  label={el.name}
                  setChosenFilters={setChosenFilters}
                  chosenFilters={chosenFilters}
                />
              );
              })}
          </UIDropdown>
        )}
    </div>
  );
};

export default ChooseColorsFilters;
